import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import { GetDB } from '../../../utils/database/firebase-budget-tool';
import { doc, onSnapshot, setDoc } from 'firebase/firestore';
import styled from 'styled-components';

const SettingsVisaWeights = () => {
    const [visaWeights, setVisaWeights] = useState({
        noVisa: 1000,
        visaOnArrival: 100,
        eVisa: 10,
        paperVisa: 1,
        restricted: 0
    });

    const db = GetDB();

    useEffect(() => {
        const unsubscribeWeights = onSnapshot(doc(db, 'Settings', 'visaWeights'), (docSnapshot) => {
            if (docSnapshot.exists()) {
                setVisaWeights(docSnapshot.data());
            } else {
                // Initialize weights if they don't exist
                setDoc(doc(db, 'Settings', 'visaWeights'), visaWeights);
            }
        });

        return () => unsubscribeWeights();
    }, []);

    const handleWeightChange = async (type, value) => {
        try {
            const newWeights = { ...visaWeights, [type]: value };
            await setDoc(doc(db, 'Settings', 'visaWeights'), newWeights);
            setVisaWeights(newWeights);
        } catch (error) {
            console.error("Error updating weights:", error);
        }
    };

    return (
        <Container>
            <h4>Visa Requirement Weights</h4>
            <p className="text-muted mb-4">
                Adjust the weights for different visa requirements. Higher weights indicate more favorable visa conditions.
            </p>

            <WeightSettings>
                <WeightRow>
                    <WeightLabel>No Visa Required</WeightLabel>
                    <WeightInput
                        type="number"
                        value={visaWeights.noVisa}
                        onChange={(e) => handleWeightChange('noVisa', parseInt(e.target.value))}
                    />
                </WeightRow>

                <WeightRow>
                    <WeightLabel>Visa on Arrival</WeightLabel>
                    <WeightInput
                        type="number"
                        value={visaWeights.visaOnArrival}
                        onChange={(e) => handleWeightChange('visaOnArrival', parseInt(e.target.value))}
                    />
                </WeightRow>

                <WeightRow>
                    <WeightLabel>E-Visa Required</WeightLabel>
                    <WeightInput
                        type="number"
                        value={visaWeights.eVisa}
                        onChange={(e) => handleWeightChange('eVisa', parseInt(e.target.value))}
                    />
                </WeightRow>

                <WeightRow>
                    <WeightLabel>Paper Visa Required</WeightLabel>
                    <WeightInput
                        type="number"
                        value={visaWeights.paperVisa}
                        onChange={(e) => handleWeightChange('paperVisa', parseInt(e.target.value))}
                    />
                </WeightRow>

                <WeightRow>
                    <WeightLabel>Restricted</WeightLabel>
                    <WeightInput
                        type="number"
                        value={visaWeights.restricted}
                        onChange={(e) => handleWeightChange('restricted', parseInt(e.target.value))}
                    />
                </WeightRow>
            </WeightSettings>
        </Container>
    );
};

const Container = styled.div`
    padding: 20px;
`;

const WeightSettings = styled.div`
    max-width: 600px;
    margin: 0 auto;
`;

const WeightRow = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding: 10px;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 8px;
`;

const WeightLabel = styled.div`
    flex: 1;
    font-weight: 500;
`;

const WeightInput = styled.input`
    width: 100px;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    text-align: right;
    
    &:focus {
        outline: none;
        border-color: ${props => props.theme.primaryAccent};
        box-shadow: 0 0 0 1px ${props => props.theme.primaryAccent};
    }
`;

export default SettingsVisaWeights; 